import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { AppConfig } from '../AppConfig';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

export const Toast = (props) => {
  return (
    <Snackbar
      open={props.open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={5000}
      onClose={props.handleClose}
    >
      <Alert
        // onClose={props.handleClose}
        classes={{
          filledInfo: css(Styles.info),
          filledSuccess: css(Styles.success),
          filledError: css(Styles.error, props.error)
        }}
        severity={props.severity}>
        {props.message}
      </Alert>
    </Snackbar>
  )
}

const Styles = StyleSheet.create({
  success: {
    color: 'white',
    borderRadius: 30
  },
  error: {
    backgroundColor: '#D50000',
    color: 'white',
    borderRadius: 30
  },
  info: {
    backgroundColor: AppConfig.TINT_COLOUR,
    color: '#ffffff',
    borderRadius: 30
  }
})



// WEBPACK FOOTER //
// ./src/components/Toast.js